import * as Sentry from "@sentry/react";

export function initSentry() {
  const isProd = process.env.NODE_ENV === "production";
  const dsn = process.env.REACT_APP_SENTRY_DSN;

  if (!isProd) {
    window.SENTRY_TEST = () => {
      throw new Error("Sentry test event");
    };
    window.SENTRY_MESSAGE = () => {
      Sentry.captureMessage("Sentry test message", "info");
    };
    window.__SENTRY_TEST__ = window.SENTRY_TEST;
    window.__SENTRY_MESSAGE__ = window.SENTRY_MESSAGE;
  }

  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0),
  });

  Sentry.setTag("app", "shop-frontend");
}